<template>
  <div class="echarts-menu">
    <a-tabs
      class="tabs"
      v-model="activeKey"
      v-for="item in dataMenu"
      :key="item.index"
      @click="changeData(item)"
      @change="onChange"
    >
      <a-tab-pane :key="item.index" :tab="item.name"></a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
export default {
  name: "echarts-menu",
  props: {
    //传参
    dataMenu: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeKey: 1,
    };
  },
  watch: {},
  mounted() {},
  methods: {
    changeData(val) {
      //向外抛出事件+参数
      this.$emit("changeydata", val);
    },
    onChange(value) {
      console.log(value);
    },
  },
};
</script>
<style lang="scss" scoped>
//less语法 可嵌套css样式前缀相同可省略为&-
.tabs {
  position: relative;
  width: 50%;
  top: 10px;
  left: 10px;
}
.echarts-menu {
  width: 100%;
  margin-top: 10px;
  margin: 0;
  margin-top: 20px;
  display: flex;
  background-color: #fff;
  &-text {
    cursor: pointer;
    margin: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/echarts-menu.vue